// extracted by mini-css-extract-plugin
export default {"language-picker":"VqdZpeS","language-picker__visually-hidden":"g22MhBq","language-picker__select":"EQz6hpH","language-picker__icon":"eBt7va9"};